import { Info, ShieldCheck, Wallet, Zap } from "lucide-react";
import React, { useEffect } from "react";

function ViewQuotation({ data, isOpen, onClose }) {

  const maxPlans = Math.max(
    data?.quotation.plans?.length || 0)

  useEffect(() => {
    console.log("quotation data", data);
    console.log("maxplans", maxPlans);
    
  
  }, [data, maxPlans])

    if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
      />
      {/* Modal Card */}
      <div className="relative bg-white w-[95%] max-h-[90%] overflow-y-auto max-w-2xl rounded-2xl shadow-2xl py-6 px-2 md:p-8 animate-[fadeIn_.25s_ease-out]">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-4 mb-6">
          <h2 className="text-2xl font-semibold text-gray-800">
            Quotation Details
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-red-500 transition text-xl"
          >
            ✕
          </button>
        </div>

      <PremiumQuotationTable data={data} maxPlans={maxPlans}/>

        {/* Footer */}
        <div className="mt-8 text-right">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewQuotation;

const PremiumQuotationTable = ({ data, maxPlans }) => {
  return (
    <div className=" px-2 bg-slate-50  rounded-3xl ">
      {/* Table Container */}
      <div className="overflow-x-auto  bg-white/80 backdrop-blur-md rounded-2xl border border-slate-200 shadow-xl">
        <table className="w-full text-left border-separate border-spacing-0">
          <thead>
            <tr className="bg-slate-900 text-white">
              <th className="p-5 text-sm font-semibold tracking-wide rounded-tl-2xl">
                <div className="flex items-center gap-2">
                  <ShieldCheck size={18} className="text-blue-400" />
                  Service Details
                </div>
              </th>
              <th className="p-5 text-sm font-semibold tracking-wide border-l border-slate-700">
                Product Info
              </th>
              {/* Dynamic Plan Headers */}
              {Array.from({ length: maxPlans }).map((_, idx) => (
                <th key={idx} className="p-5 text-center text-sm font-semibold tracking-wide border-l border-slate-700">
                  <div className="text-slate-400 text-[10px] uppercase mb-1">Tier {idx + 1}</div>
                  Pricing Plan
                </th>
              ))}
            </tr>
          </thead>
          
          <tbody className="divide-y divide-slate-100">
            <tr className="hover:bg-blue-50/50 transition-colors group">
              <td className="p-6">
                <span className="block text-xs font-bold text-blue-600 uppercase mb-1">Category</span>
                <span className="text-lg font-bold text-slate-800 leading-tight">
                  {data?.quotation.category_name}
                </span>
              </td>
              <td className="p-6 border-l border-slate-100">
                <span className="block text-xs font-bold text-slate-400 uppercase mb-1">API Name</span>
                <span className="text-md font-semibold text-slate-700">
                  {data?.quotation.service_name}
                </span>
              </td>

              {data?.quotation.plans?.map((plan, i) => (
                <td key={i} className="p-6 border-l border-slate-100 text-center">
                  <div className="inline-flex flex-col items-center">
                    <span className="text-xl font-black text-slate-900 tracking-tight">
                      ₹{plan.system_price}
                    </span>
                    <span className="text-[10px] font-bold text-slate-400 uppercase mt-1">
                      Per Hit
                    </span>
                  </div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      {/* Footer Section: Setup & Wallets */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* One Time Setup Card */}
        <div className="bg-gradient-to-br from-blue-600 to-indigo-700 p-6 rounded-2xl shadow-lg shadow-blue-200 text-white relative overflow-hidden group">
          <Zap className="absolute right-[-10px] top-[-10px] w-24 h-24 text-white/10 group-hover:scale-110 transition-transform" />
          <h3 className="text-blue-100 text-sm font-bold uppercase tracking-widest mb-2">Setup Investment</h3>
          <div className="flex items-baseline gap-2">
            <span className="text-4xl font-black tracking-tighter">₹{data.quotation.one_time_setup_fee}</span>
            <span className="text-blue-200 text-sm italic">one-time</span>
          </div>
          <p className="mt-4 text-xs text-blue-100/80 flex items-center gap-1">
            <Info size={12} /> Standard API integration & priority support included.
          </p>
        </div>

        {/* Wallet Options Card */}
        <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-lg flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="p-2 bg-emerald-100 rounded-lg">
                <Wallet className="text-emerald-600" size={20} />
              </div>
              <h3 className="font-bold text-slate-800">Wallet Recharge Options</h3>
            </div>
            <div className="flex flex-wrap gap-2">
              {data.quotation.plans?.map((item, idx) => (
                <div key={idx} className="px-4 py-2 bg-slate-50 border border-slate-200 rounded-full text-sm font-mono font-bold text-slate-700 hover:border-emerald-500 hover:text-emerald-600 transition-all cursor-default">
                  ₹{item.wallet_topup}
                </div>
              ))}
            </div>
          </div>
          <p className="mt-4 text-[11px] italic text-slate-400">
            * Wallet balances are required in case of OTS (On-Tap Service).
          </p>
        </div>
      </div>
    </div>
  );
};

